import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckBox, FlexContainer, Text } from '@bos/ui';
import { useController } from 'react-hook-form';
export const CheckBoxField = ({ control, name, registerOptions, ...checkBoxProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        ...registerOptions,
    });
    const handleCheckedChange = (isChecked) => field.onChange(isChecked);
    const { error } = fieldState;
    const maybeErrorMessage = error?.message && (_jsx(Text, { color: 'danger', variant: 'b3', children: error.message }));
    return (_jsxs(FlexContainer, { direction: 'column', gap: true, children: [_jsx(CheckBox, { ...checkBoxProps, checked: field.value, onCheckedChange: handleCheckedChange }), maybeErrorMessage] }));
};
